export const h = {
  case: {
    title: "案例信息設置",
    name: "名稱",
    coverImage: "封面圖",
    describe: "描述",
    uploadDesc: "點擊上傳圖片,建議尺寸為(500*375)",
    shareLink: "分享鏈接設置",
    expiration: "永不過期",
    on: "開",
    off: "關",
    failureTime: "失效時間",
    pickDay: "請選擇日期",
    pickerOptions: {
      shortcuts: [
        {
          text: "一天后",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            return date;
          },
        },
        {
          text: "一周后",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            return date;
          },
        },
        {
          text: "30天后",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
            return date;
          },
        },
      ],
    },
    dateCannotEmpty: "日期不能為空",
    nameCannotEmpty: "名稱不能為空！",
    descCannotEmpty: "描述不能為空！",
    logoSet: "logo設置",
    selectAll: "全選",
    noBrand: "暫無品牌",
    openEffect: "開場效果",
    closeOpenMode: "無",
    asteroidOpen: "小行星開場",
    horizontalOpen: "水平巡遊開場",
    asteroidCruise: "小行星巡遊開場",
    Crystal: "水晶球開場",
    asteroidScale: "小行星縮放開場",
    limitImage: "圖片尺寸過大，請限制圖片大小不超過4M",
    imageType: "圖片類型錯誤，請上傳png、jpg格式的圖片",
  },
  slide: {
    case: "案例",
    save: "保存",
    view: "查看",
    panorama: "全景",
    angleView: "視角",
    hotspot: "熱點",
    music: "音樂",
    designer: "設計師",
    beautify: "美化",
  },
  list: {
    title: "全景列表設置",
    draganoramicsort: "拖動全景排序",
    resetSort: "重置排序",
    addPanoramic: "新增全景",
    customThumbnailImages: "自定義縮略圖",
    more: "更多",
    downloadImage: "下載全景圖片",
    replaceImage: "替換全景圖片",
    downloadImagePackage: "下載全景圖包",
    downloadDiagram: "下載通道圖",
    ApplyThumbnailToImage: "將此縮略圖應用到案例封面圖",
    VoiceBroadcast: "語音播報信息",
    restoreImage: "還原全景圖片",
    uploadImage: "點擊上傳圖片",
    upgradePackage: "升級套餐",
    eidt: "全景修改",
    name: "全景名稱",
    thumbnail: "縮略圖",
    enterName: "輸入全景名稱",
    uploadDesc: "點擊上傳圖片,建議尺寸為(500*375)",
    confirm: "確定",
    cannotEmpty: "全景名稱不能為空",
    selectToAdd: "選擇全景新增",
    selectAll: "全選本頁",
    StartAndEnd: "起止時間",
    schemeName: "渲染方案名稱",
    清晰度: "清晰度",
    searchThisPlan: "按本方案查詢",
    search: "查詢",
    empty: "當前時間段內，沒有渲染的場景",
    dateOptions: {
      shortcuts: [
        {
          text: "今天",
          value() {
            const end = new Date(
              new Date(new Date().toLocaleDateString()).getTime() +
                24 * 60 * 60 * 1000 -
                1
            );
            const start = new Date(
              new Date(new Date().toLocaleDateString()).getTime()
            );
            return [start, end];
          },
        },
        {
          text: "3天前",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
            return [start, end];
          },
        },
        {
          text: "1周前",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          },
        },
        {
          text: "30天前",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          },
        },
        {
          text: "90天前",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          },
        },
      ],
    },
    loading: "加載中...",
    sceneAlreadyExists: "當前全景列表已存在此場景",
    previewImage: "當前全景為快速預覽圖",
    applyToThumbnail: "應用到縮略圖",
    delete: "刪除",
    content: "刪除該場景，會刪除其它場景中指向該場景的熱點，是否繼續刪除？",
    captureScreen: "截取屏幕中",
    generateScreenshots: "生成屏幕截圖",
    thumbnailApply: "應用縮略圖成功，保存后生效",
    atLeastOne: "請至少保留一個場景~",
    downloadCompleted: "下載完成！",
    fielDownloadFailed: "文件下載失敗！",
    limitImageSize: "圖片尺寸過大，請限制圖片大小不超過",
    imageType: "圖片類型錯誤，請上傳png、jpg格式的圖片",
    imageAspectRatio: "請上傳寬高比為",
    replaceFailed: "替換失敗,請重試",
    uploadFailed: "上傳失敗,請重試",
    restoreFailed: "還原失敗",
    applySuccess: "應用成功，保存后生效",
    dateCannotEmpty: "日期不能為空",
    全部: "全部",
    快速预览: "快速預覽",
  },
  camera: {
    rotationSettings: "旋轉設置",
    turnOnRotation: "開啟旋轉",
    waitTime: "等待時間(秒)",
    clickSettings: "一鍵設置",
    rotationInfoBefore: "您確認將當前旋轉狀態應用到當前場景列表的",
    rotationInfoAfter: "個場景，並保存嗎？",
    cameraSettings: "鏡頭設置",
    recently: "最近：場景縮放時的最小視域",
    initial: "初始：進入場景的初始視域",
    farthest: "最遠：場景縮放時的最大視域",
    recommended: "推薦設置：最近70，初始95，最遠125",
    viewingAngle: "視角範圍",
    recentlyt: "最近",
    initialt: "初始",
    farthestt: "最遠",
    viewInfoFirst: "您確認將當前視野範圍（最近：",
    viewInfoSecend: "）應用到當前場景列表的",
    viewInfoThird: "個場景，並保存嗎？",
    inCommonUse: "設為常用",
    reset: "重置",
    stapleInfo: "將當前視角範圍保存為我的常用鏡頭",
    commonLenses: "常用鏡頭",
    systemLens: "系統鏡頭",
    restoreInfo: "恢復當前場景的視野範圍初始值",
    restoreDefault: "恢復默認成功",
    recommendedLens: "使用推薦鏡頭成功，保存后生效",
    usedLenses: "使用常用鏡頭成功，保存后生效",
    initialViewpoint: "初始視角設置成功，保存后生效",
    setCommonLens: "設置常用鏡頭成功",
    initialPerspective: "設為初始視角",
  },
  hotspot: {
    addHotspots: "新增熱點",
    clear: "清空",
    clearHotspots: "清空熱點",
    clearHotspotsForCurrentScene: "清空當前場景熱點列表",
    editHotspots: "編輯熱點",
    return: "返回",
    hotspotType: "熱點類型",
    type: "類型",
    hotspotList: "當前場景熱點列表",
    all: "全部",
    navigation: "導航",
    link: "超鏈接",
    image: "圖片",
    deleteHotspot: "確認刪除此熱點",
    style: "樣式",
    hotspotName: "熱點名稱",
    name: "名稱",
    enterHotspotName: "請輸入熱點名稱",
    targetPanorama: "目標全景",
    ok: "確認",
    cancel: "取消",
    edit: "修改",
    delete: "刪除",
    confirmDelete: "確認刪除此熱點",
    hotspotImage: "熱點圖片",
    uploadImage: "點擊上傳圖片",
    editImage: "修改圖片",
    addImage: "添加圖片",
    hotspotAddress: "熱點地址",
    address: "地址",
    targetUrl: "請輸入目標URL",
    videoAddress: "視頻地址",
    videoUrl: "請輸入視頻URL",
    targetNoEmpty: "目標場景不能為空",
    noTarget: "暫無目標場景",
    hotspotNameNoEmpty: "熱點名稱不能為空",
    hotspotDetailNoEmpty: "熱點詳情不能為空",
    linkNoEmpty: "鏈接地址不能為空",
    linkIncorrect: "鏈接地址格式不正確",
    videoNoEmpty: "視頻鏈接地址不能為空",
    pleaseUploadImage: "請先上傳熱點圖片",
    limitImage: "圖片尺寸過大，請限制圖片大小不超過30M",
    uploadFailed: "上傳失敗,請重試",
    uploadSuccessful: "上傳成功",
    imageType: "圖片類型錯誤，請上傳png、jpg格式的圖片",
    noHotSpots: "當前場景暫無熱點",
    text: "文本",
    video: "視頻",
    hotspotDetail: "熱點詳情",
    detail: "詳情",
    noOtherScene: "暫無其他場景",
    enterHotspotDetail: "請輸入熱點詳情",
    videoResources: "視頻資源",
    clickToSwitch: "點擊切換",
    clickUploadVideo: "點擊上傳視頻",
    videoFormat: "支持MP4格式，最大不超過100M",
    enerVideoUrl: "請輸入視頻URL",
  },
  music: {
    musicSettings: "音樂設置",
    trialListening: "試聽",
    stopListening: "停止試聽",
    setMusic: "設置音樂",
    backgroundMusic: "背景音樂",
    SystemMusicLibrary: "系統曲庫",
    selected: "已選擇",
    myMusic: "我的音樂",
    uploadMusic: "上傳音樂",
    upgradePackage: "升級套餐",
    uploadAgree: "上傳即同意",
    disclaimer: "請先勾選免責聲明",
    musicName: "請輸入音樂名稱",
    deleteMusic: "刪除音樂",
    noCustomMusic: "暫無自定義音樂",
    onlineMusic: "線上音樂",
    operationProcess: "操作流程",
    oneStep:
      "找到正確的音頻鏈接，在瀏覽器輸入欄中輸入音頻鏈接，若可以播放或下載，一般就是正確的音頻鏈接；",
    twoStep: "將音頻鏈接粘貼到上方輸入欄中；",
    threeStep: "先點擊確定按鈕,再點擊左上角保存即可。",
    ok: "確定",
    placeholderInfo: "輸入網上音樂地址，並保證音樂可用性",
    musicAddress: "請輸入音樂地址",
    limitMusic: "音樂地址過長,請限制地址長度不超過150字符",
    saveMusic: "請先選擇音樂再保存",
    linkIncorrect: "鏈接地址格式不正確",
    musicNonEmpty: "音樂名稱不能為空",
    eidtFailed: "修改失敗",
    deleteSuccess: "刪除成功",
    deleteFailed: "刪除失敗",
    limitNameCharacter: "文件名稱超過50字符,請修改后再上傳",
    limitFileSize: "文件過大,請限制文件不超過10M",
    limitFileType: "文件格式錯誤,請上傳mp3或wav格式文件",
    limitFileNumber: "文件過多,最多限制上傳30個文件",
    uploadFailed: "上傳失敗,請重試",
    uploadSuccessful: "上傳成功",
    disclaimerInfo: "免責聲明",
  },
  design: {
    designerInfo: "設計師信息設置",
    name: "姓名",
    enterName: "輸入名稱",
    phone: "電話",
    enterPhone: "輸入電話",
    avater: "頭像",
    uploadImageInfo: "點擊上傳圖片,建議尺寸為(64*64)",
    nameNonEmpty: "姓名不能為空！",
    phoneNonEmpty: "電話不能為空！",
    phoneNumber: "請輸入正確的電話號碼！",
    limitImage: "圖片尺寸過大，請限制圖片大小不超過4M",
    imageType: "圖片類型錯誤，請上傳png、jpg格式的圖片",
  },
  beauty: {
    filterSet: "濾鏡設置",
    colorSet: "色彩設置",
    brightness: "亮度",
    contrastRatio: "對比度",
    saturation: "飽和度",
    hue: "色相",
    restoreDefault: "恢復默認",
    compareOriginalImage: "對比原圖",
    originalImage: "按住顯示原圖",
    noFilter: "無濾鏡",
    warmYellow: "溫馨黃",
    romanticPurple: "浪漫紫",
    modernGrey: "摩登灰",
    restoreSuccessful: "恢復默認成功",
  },
  tipInfo: {
    tip: "提示",
    switchNavigation: "切換導航",
    fillCorrectly: "請正確填寫后",
    panoramaEditor: "全景編輯器",
    editSave: "請編輯后保存",
    viewSave: "您還有未保存的信息，請先操作保存之後進行查看",
    saveView: "保存查看",
    save: "保存中",
    saveSuccess: "保存成功",
    请填写必填项后再进行编辑: "請填寫必填項后再進行編輯",
  },
  loading: {
    schemeLoading: "方案加載中...",
    loadingTitle: "致力做最好的一體化家居設計平台",
    loadingStrives: "天工智家傾力打造",
  },
  driver: {
    案例详情: "案例詳情",
    修改全景名称描述等:
      "修改全景名稱、描述等，設置全景過期時間，控制品牌logo的顯示等。",
    下一步: "下一步",
    上一步: "上一步",
    关闭: "關閉",
    完成: "完成",
    全景列表: "全景列表",
    增加删除修改场景:
      "增加、刪除、修改場景，下載全景圖片，替換全景縮略圖，修改全景名稱等。",
    视角设置: "視角設置",
    设置全景是否开启自动旋转:
      "設置全景是否開啟自動旋轉； 全景的初始視角信息等。",
    热点设置: "熱點設置",
    增加新的热点或修改已有热点: "增加新的熱點或修改已有熱點。",
    设置音乐: "設置音樂",
    设计师信息设置: "設計師信息設置",
    设置设计师头像姓名: "設置設計師頭像，姓名，聯繫方式等信息。",
    美化设置: "美化設置",
    设置全景滤镜效果: "設置全景濾鏡效果； 修改全景色彩亮度、對比度、色相等。",
  },
  video: {
    视频转换: "視頻轉換",
    上传视频: "上傳視頻",
    视频格式错误请重新上传视频将转码转码时无法使用全景其他功能:
      "視頻格式錯誤，請重新上傳。 視頻將轉碼，轉碼時無法使用全景其他功能。",
    支持MP4格式最大不超过300M: "支持MP4格式，最大不超過300M",
    上传视频编码错误请重新上传: "上傳視頻編碼錯誤，請重新上傳",
    视频转换中: "視頻轉換中...",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/lan/cht.js